/* eslint-disable no-dupe-keys */
/* eslint-disable semi */
/* eslint-disable space-before-function-paren */
/* eslint-disable quotes */
/* eslint-disable comma-spacing */
import ApiService from "../../ApiService";

const coverageAreaService = {
  getCoverageArea(page, PerPage, searchString) {
    return ApiService.get(`/branch-city/?page=${page}&perPage=${PerPage}&searchString=${searchString}`);
  },

  getCoverageAreaesByprovider(providerId) {
    providerId = providerId || 0;
    return ApiService.get(`/CoverageArea/provider/${providerId}`);
  },
  validateCitie(providerId, editFunction, city, state) {
    const data = {
      providerId,
      editFunction,
      city,
      state
    }
    return ApiService.post(`/branch-city/validate-branch/`, data)
  },

  createCoverageArea(formData) {
    return ApiService.post("/branch-city", formData);
  },

  createNovelty(formData) {
    return ApiService.post("/novelty", formData);
  },

  getNovelty(idNovelty) {
    return ApiService.get(`/novelty/${idNovelty}`);
  }
};

export default coverageAreaService;
